'use client'

import { safeHtml } from 'shared/utils/sanitize'
import { addTestId } from 'shared/utils/tests'

import styles from './CartSummaryPriceItem.module.scss'

const CartSummaryPriceItem = ({
  label,
  amount,
  type,
  tag
}: {
  label: string
  amount: string
  type?: 'total'
  tag?: string
}) => (
  <div className={styles.row} {...(tag && addTestId(tag))}>
    <div className={styles.label}>{label}</div>
    {type === 'total' ? (
      <div
        className={styles.totalAmount}
        dangerouslySetInnerHTML={{ __html: safeHtml(amount) }}
      />
    ) : (
      <div
        className={styles.label}
        dangerouslySetInnerHTML={{ __html: safeHtml(amount) }}
      />
    )}
  </div>
)

export default CartSummaryPriceItem
